import {
  Document,
  Image,
  Font,
  Page,
  Text,
  View,
  StyleSheet,
} from "@react-pdf/renderer";

import RobotoBlack from "fonts/Roboto-Black.ttf";

Font.register({
  family: "Roboto",
  fonts: [{ src: RobotoBlack, fontWeight: 900 }],
});

const StickerCartBoxQrCode = ({ data }) => (
  <Document>
    <Page size={{ width: 310, height: 60 }} style={styles.page}>
      <View style={styles.wrapper}>
        {data?.length > 0 &&
          data.map(({ cart_name, cart_box_identifier, qr_code_base_64 }) => (
            <View style={styles.box} key={cart_box_identifier}>
              <View style={styles.box_image}>
                <Image
                  src={qr_code_base_64}
                  style={{
                    width: 50,
                    height: 50,
                  }}
                />
              </View>
              <View style={styles.box_sku}>
                <Text style={styles.box_sku__text}>{cart_name}</Text>
                <Text style={styles.box_sku__text}>{cart_box_identifier}</Text>
              </View>
            </View>
          ))}
      </View>
    </Page>
  </Document>
);

export default StickerCartBoxQrCode;

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#fff",
  },
  wrapper: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "flex-start",
  },
  box: {
    position: "relative",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: 103.33333,
    height: 60,
  },
  text_wrapper: {
    justifyContent: "flex-end",
    paddingBottom: 5,
    paddingLeft: 12,
  },
  text_normal: {
    fontFamily: "Roboto",
    fontSize: 7,
    fontWeight: 900,
    marginBottom: 3,
  },
  box_image: {
    flexBasis: 60,
    paddingLeft: 10
  },
  box_sku: {
    position: "absolute",
    left: 65,
    bottom: -3,
    width: 60,
    transform: "rotate(-90deg)",
    transformOrigin: "0% 0%",
  },
  box_sku__text: {
    fontFamily: "Roboto",
    fontSize: 6,
    fontWeight: 900,
  },
});
